import React from "react";

const formatNumber = (num) => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(num % 1000000 === 0 ? 0 : 1)}M`;
  }

  if (num >= 1000) {
    return `${(num / 1000).toFixed(num % 1000 === 0 ? 0 : 1)}k`;
  }

  return num;
};

const PaginationInfo = ({
  totalCount = 0,
  currentPage = 1,
  rowsPerPage = 10,
  itemName = "item",
  suffixText = "",
  className = "",
  loadedCount,
}) => {
  const itemText = totalCount === 1 ? itemName : `${itemName}s`;

  const displayText =
    loadedCount != null
      ? `${formatNumber(Math.min(loadedCount, totalCount))} of ${formatNumber(totalCount)}`
      : totalCount > 0
        ? `${formatNumber((currentPage - 1) * rowsPerPage + 1)}-${formatNumber(
            Math.min(currentPage * rowsPerPage, totalCount),
          )} of ${formatNumber(totalCount)}`
        : "0";

  return (
    <p className={`text-xs text-gray-500 dark:text-gray-400 font-normal ${className}`}>
      Showing{" "}
      <span className="text-gray-800 dark:text-gray-100 font-bold">
        {displayText} {itemText}
      </span>
      {suffixText && ` ${suffixText}`}
    </p>
  );
};

export default PaginationInfo;
